// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFoundPage_container__3EC9V","status":"NotFoundPage_status__XERFS","heading":"NotFoundPage_heading__eZT8E"};